/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Loading from 'app/components/common/Loading.jsx';
import Content from 'app/components/common/Content.jsx';
import QueueTabs from 'app/components/Queue/QueueTabs.jsx';
import EverqueuePost from 'app/components/Everqueue/EverqueuePost.jsx';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';
import EmptyState from 'app/components/common/EmptyState.jsx';
import FeatureUpgradeComponent from 'app/components/Subscription/FeatureUpgradeComponent.jsx';
import * as _ from 'underscore';
import { Link } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import InfiniteScroll from 'react-infinite-scroller';
import Utilities from 'app/utility/Utilities.js';

class EverqueueItems extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: {},
            itemsToDelete: [],
            modal: null,
            category: null,
            loading: false,
            currentPage: 1,
            hasMoreItems: true
        };

        this.editItem = this.editItem.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
        this.deleteAll = this.deleteAll.bind(this);
        this.onCategoryFilter = this.onCategoryFilter.bind(this);
        this.scrollHandler = this.scrollHandler.bind(this);

    }

    componentDidMount() {
        let hasAccess = this.props.user.perms.resources && this.props.user.perms.resources.everQ;

        if (this.props.socialId && hasAccess) {
            this.setState({
                loading: true
            }, () => {
                this.props.getEverqueue({
                    id: this.props.socialId,
                    page: this.state.currentPage,
                    reset: true
                });
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.socialId && this.props.socialId != prevProps.socialId) {
            this.setState({
                itemsToDelete: [],
                currentPage: 1,
                hasMoreItems: true
            }, () => {
                this.props.getEverqueue({
                    id: this.props.socialId,
                    currentPage: this.state.currentPage,
                    reset: true
                });
            });

        }

        if (prevProps.posts.created < this.props.posts.created || prevProps.posts.updated < this.props.posts.updated) {
            this.props.getEverqueue({
                id: this.props.socialId,
                currentPage: this.state.currentPage
            });
        }

        if ((prevProps.app.loading.EVERQUEUE_LIST === true && this.props.app.loading.EVERQUEUE_LIST === false) ||
            (prevProps.app.loading.EVERQUEUE_UPDATE === true && this.props.app.loading.EVERQUEUE_UPDATE === false)) {
            let hasMoreItems = this.state.hasMoreItems;

            if (this.props.everqueue.hasMore === false) {
                hasMoreItems = false;
            }

            this.setState({
                items: Utilities.deepClone(this.props.everqueue.list),
                loading: false,
                hasMoreItems
            });
        }

    }

    onCategoryFilter(category, e) {
        let categoryID = parseInt(category.id, 10);

        if (categoryID >= 0) {
            this.setState({
                category: categoryID
            });
        } else {
            this.setState({
                category: null
            });
        }

        // we need to fetch the queue items again if a category
        // is selected or deselected
        let args = {
            id: this.props.social.id,
            page: 1,
            reset: true
        };
        if (categoryID >= 0) {
            args.tagID = categoryID;
        }
        this.props.getEverqueue(args);

        this.setState({
            currentPage: 1,
            loading: true
        });

    }

    editItem(item, e) {

        let itemId = parseInt(e.currentTarget.dataset.itemid);
        let editItem = _.find(this.state.items, function(item) {
            return item.id === itemId;
        });

        this.props.persistData("everqueueItem", editItem);

        this.props.router.navigate("/content/post");

    }

    deleteItem(item, e) {

        if (e.preventDefault !== undefined) {
            e.preventDefault();
        }

        let items = this.state.itemsToDelete
        item.deleted = true;

        items.push(item.id);

        this.setState({
            itemsToDelete: items
        });

    }

    confirmDelete(e) {

        e.preventDefault();

        let itemList = Utilities.deepClone(this.state.items),
            nextItems = [];

        this.props.deleteEverqueue(this.props.socialId, this.state.itemsToDelete);

        for (let i = 0; i < itemList.length; ++i) {
            if (itemList[i].deleted !== undefined && itemList[i].deleted) {
                continue;
            }
            nextItems.push(itemList[i]);
        }

        this.setState({
            itemsToDelete: [],
            items: nextItems
        });

    }

    cancelDelete(e) {

        e.preventDefault();

        let items = this.state.itemsToDelete,
            list = this.state.items;

        for (let i = 0; i < list.length; ++i) {
            if (items.indexOf(list[i].id) !== -1) {
                delete list[i].deleted;
            }
        }

        this.setState({
            itemsToDelete: []
        });

    }

    deleteAll(e) {

        e.preventDefault();

        let onConfirm = () => {
                this.props.deleteEverqueue(this.props.socialId, null, true);
                this.props.closeAllModals();
                this.setState({
                    items: {},
                    itemsToDelete: [],
                    modal: null
                });
            },
            onCancel = () => {
                this.props.closeAllModals();
                this.setState({
                    modal: null
                });
            },
            confirmModal = null;

        confirmModal = (
            <ConfirmModal
                modalCopy="Are you sure you want to delete all items from this EverQueue queue?"
                confirmAction={onConfirm}
                cancelAction={onCancel}
                closeAction={onCancel}/>
        );

        this.setState({
            modal: confirmModal
        });

    }

    scrollHandler() {

        // fetch already in progress? bail!
        if (this.props.app.loading.EVERQUEUE_LIST === true ||
            this.state.hasMoreItems === false) {
            return;
        }

        if (this.props.socialId) {
            let nextPage = this.state.currentPage + 1;

            this.props.getEverqueue({
                id: this.props.socialId,
                page: nextPage
            });

            this.setState({
                currentPage: nextPage
            });
        }

    }

    render() {
        let header = null,
            content = null,
            itemList = [],
            items = null,
            constants = this.props.app.config.constants,
            imageUrl = this.props.app.config.assetsUrl + this.props.app.config.imageUrl,
            spinner = (
                <div key={0} className="waiting-block">
                    <i className="fa fa-spinner fa-pulse"></i>
                </div>
            );

        if (this.state.loading) {
            content = (
                <Loading />
            );
        } else if (this.props.user.perms.resources && !this.props.user.perms.resources.everQ) {
            content = (
                <FeatureUpgradeComponent
                    {...this.props}
                    context="everqueue" />
            );
        } else {
            if (this.state.items.length) {

                itemList = this.state.items;

                if (this.state.category !== null) {
                    if (this.state.category !== -1) {
                        itemList = _.filter(this.state.items, function(item) {
                            return parseInt(item.tagID, 10) === parseInt(this.state.category, 10);
                        }.bind(this));
                    }
                }

                items = (
                    <div style={{height: '1000px', overflow: 'auto'}}>
                        <InfiniteScroll
                            className="infinite-scroller queue-item"
                            threshold={300}
                            loadMore={this.scrollHandler}
                            loader={spinner}
                            hasMore={this.state.hasMoreItems}
                            useWindow={false}
                            initialLoad={false}>
                            {itemList.map((item) => {
                                return (
                                    <EverqueuePost
                                        {...this.props}
                                        social={this.props.social}
                                        key={item.id}
                                        item={item}
                                        editHandler={this.editItem}
                                        deleteHandler={this.deleteItem}
                                        categories={this.props.categories}
                                        category={this.props.category}
                                        user={this.props.user}
                                        everqueueActive={this.props.social.poolActive} />
                                );
                            })}
                        </InfiniteScroll>
                    </div>
                )

            } else if (this.state.category !== null && !this.state.items.length) {
                items = (
                    <div className="everqueue-empty">
                        <h3>This Category is Empty</h3>
                        <Link to="/content/import" className="user-action">Try our Bulk Import & Discovery Tool</Link>
                    </div>
                );
            } else {
                items = (
                    <div className="everqueue-empty">
                        <h3>This EverQueue is Empty</h3>
                        <p className="sub-head">Add your best posts and we’ll recycle them for you.</p>
                        <img className="tumbleweeds" width="75" height="63" src={imageUrl + '/misc/tumbleweed.png'} srcSet={imageUrl + '/misc/tumbleweed@2x.png' + " 2x"}/>
                        <p className="user-action no-link">Instantly fill your EverQueue</p>
                        <Link to="/content/import" className="user-action">Try our Bulk Import & Discovery Tool</Link>
                    </div>
                );
            }
            header = (
                <QueueTabs
                    {...this.props}
                    selectedForDelete={this.state.itemsToDelete.length}
                    cancelDelete={this.cancelDelete}
                    finalizeDelete={this.confirmDelete}
                    deleteAll={this.deleteAll}
                    onCategoryFilter={this.onCategoryFilter}
                    category={this.state.category}
                    source="everqueue" />
            );
            content = (
                <div>
                    {items}
                </div>
            )
        }

        return (
            <Content {...this.props} header={header} main={content} modal={this.state.modal}/>
        );

    }
}

EverqueueItems.displayName = "EverqueueItems";

EverqueueItems.propTypes = {
    socialId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    user: PropTypes.object,
    userPerms: PropTypes.object
};

EverqueueItems.defaultProps = {
    socialId: 0,
    user: {},
    userPerms: {}
};

export default ComponentWithContext(EverqueueItems);
